{
  "name": "mobo-web",
  "version": "1.0.12",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --proxy-config proxy.config.js --configuration development -o",
    "build": "npm run generate:routes && ng build --verbose true",
    "build:homol": "npm run generate:routes && ng build --configuration homol --verbose true",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "server": "ng build --configuration development --verbose true && node dist/mobo-web/server/server.mjs",
    "generate:routes": "node generate-routes.js"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^17.0.2",
    "@angular/common": "^17.0.2",
    "@angular/compiler": "^17.0.2",
    "@angular/core": "^17.0.2",
    "@angular/forms": "^17.0.2",
    "@angular/platform-browser": "^17.0.2",
    "@angular/platform-browser-dynamic": "^17.0.2",
    "@angular/platform-server": "^17.0.2",
    "@angular/router": "^17.0.2",
    "@angular/ssr": "^17.0.0",
    "@netlify/functions": "^2.3.0",
    "axios": "^1.9.0",
    "express": "^4.18.2",
    "hammerjs": "^2.0.8",
    "ngx-toastr": "^19.0.0",
    "rxjs": "~7.8.0",
    "serverless-http": "^3.2.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.14.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^17.0.0",
    "@angular/cli": "^17.0.0",
    "@angular/compiler-cli": "^17.0.2",
    "@types/express": "^4.17.21",
    "@types/hammerjs": "^2.0.46",
    "@types/jasmine": "~5.1.0",
    "@types/node": "^18.18.9",
    "autoprefixer": "^10.4.16",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "ng-packagr": "^17.0.0",
    "postcss": "^8.4.31",
    "tailwindcss": "^3.3.3",
    "typescript": "~5.2.2"
  }
}
